export default __webpack_public_path__ + "static/media/property_1_21.ca23eb80.webp";